import React, { FC } from 'react';

import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import MessagesCard from '@ui/organisms/MessagesCard';
import ProfileDropdown from '@ui/organisms/ProfileDropdown';

import fullWidth from '@ui/styled/FullWidth';
import spaced from '@ui/styled/Spaced';

import { IPageProps } from '@folx-types/flow-steps';

import Medkit from '@assets/vectors/medkit.inline.svg';
import QuestionMark from '@assets/vectors/question-mark.inline.svg';

export interface IMessagesStepPageContent {
	pageHeader: string;
	careTeamHeader: string;
	careTeamSubheader: string;
	careTeamCta: string;
	careTeamHref: string;
	careTeamDescription: string;
	careTeamList: string;
	supportHeader: string;
	supportSubheader: string;
	supportCta: string;
	supportHref: string;
	supportDescription: string;
	supportList: string;
	pageFineprint: string;
}

interface IMessagesStepProps extends IPageProps {
	pageContent: IMessagesStepPageContent;
	showCareTeamCard?: boolean;
}

const SpacedHeading = spaced(HeadingText);
const SpacedColumn = spaced<IFlexColumn>(fullWidth<IFlexColumn>(FlexColumn));

const MessagesStep: FC<IMessagesStepProps> = ({ pageContent, showCareTeamCard }) => {
	const {
		pageHeader,
		careTeamHeader,
		careTeamSubheader,
		careTeamCta,
		careTeamHref,
		careTeamDescription,
		careTeamList,
		supportHeader,
		supportSubheader,
		supportCta,
		supportHref,
		supportDescription,
		supportList,
		pageFineprint,
	} = pageContent;

	const careTeamCard = (
		<MessagesCard
			header={careTeamHeader}
			subheader={careTeamSubheader}
			cta={careTeamCta}
			description={careTeamDescription}
			href={careTeamHref}
			list={careTeamList}
			Icon={Medkit}
		/>
	);

	const supportCard = (
		<MessagesCard
			header={supportHeader}
			subheader={supportSubheader}
			cta={supportCta}
			description={supportDescription}
			href={supportHref}
			list={supportList}
			Icon={QuestionMark}
		/>
	);

	return (
		<SpacedColumn gap="lg" marginBottom="xxxl">
			<ProfileDropdown />
			<FlexColumn gap="sm">
				<SpacedHeading marginBottom="md">{pageHeader}</SpacedHeading>
				{showCareTeamCard && careTeamCard}
				{supportCard}
			</FlexColumn>
			<WYSIWYGContent dangerouslySetInnerHTML={{ __html: pageFineprint }} />
		</SpacedColumn>
	);
};

export default MessagesStep;
